export const topBarHeight = 64;
export const sideNavWidth = 260;
export const navbarHeight = 60;
export const sidenavCompactWidth = 80;
export const containedLayoutWidth = 1200;

const COMMONVARIABLES = {
    VERSION: 'v1.0',

    'STATUS': {
        SUCCESS: 200,
        LOGIN_SUCCESS: '101',
        INACTIVE_USER: '104',
        INVALID_CREDENTIALS: '102',
        EXISTS: 201,
        UNAUTHORIZED: 401,
        INVALIDUSER: 402,
        EXPIRED_TOKEN: 498,
        ALREADY_IN_USE: 202,
        ERROR: 500,
        NETWORK_ERROR_STATUS: 'ERR_NETWORK',
        BAD_REQUEST_ERROR_STATUS: 'ERR_BAD_REQUEST',
        SERVICE_CATCH_STATUS: 500,
    },
};

export default COMMONVARIABLES;
